<template>
  <div class="w-full border-t border-b border-gray-300 bg-gray-100 py-4 hidden lg:block">

    <template v-if="$store.state.view == 'broker'">
      <template v-if="$store.state[$store.state.view + 'Module'].broker.subscription != null && $store.state[$store.state.view + 'Module'].broker.subscription.stripe != null">
      </template>

      <template v-else>
        <template v-if="$store.state[$store.state.view + 'Module'].broker.trial_ended">
          
        </template>

        <template v-else>
          <div class="fixed top-0 left-0 w-full text-center" v-if="$store.state.user.group_id == null">
            <router-link :to="{
              name : 'broker-stripe',
              params : {
                brokerId : $store.state[$store.state.view + 'Module'].broker.id
              }
            }"
            tag="a"
            style="border-radius: 0 0 5px 5px;"
            class="py-2 px-8 inline-block bg-indigo-500 text-white font-semibold">You are currently on Free Trial. Subscribe to a plan now!</router-link>
          </div>
        </template>
      </template>
    </template>



    <div class="w-full px-6 xxl:px-0 xxl:w-3/5 m-auto flex items-center justify-between">
      <div class="">
        <router-link :to="{
          name: $store.state.view == 'broker' ? 'broker-home' : 'client-home'
        }" tag="a" class="ml-1 sub-header-link">Home</router-link>

        <!-- following are only available for brokers -->
        <template v-if="$store.state.view == 'broker'">

          <span class="px-2 text-gray-400">/</span>
          <router-link :to="{ name: 'client-list' }" tag="a" class="sub-header-link">Client List</router-link>

          <template v-if="showMercuryOption">
            <span class="px-2 text-gray-400">/</span>
            <a href="https://m5.connective.com.au/mercury5/"
              target="_blank"
              class="sub-header-link">Go to Mercury</a>
          </template>

          <span class="px-2 text-gray-400">/</span>
          <router-link :to="{
            name  : 'broker-account',
            params: {
              brokerId : $store.state[$store.state.view + 'Module'].broker.id
            }
          }" tag="a" class="sub-header-link">My Settings</router-link>
        </template>

        <span class="px-2 text-gray-400">/</span>
        <a href="#" v-on:click.prevent="$modal.show('feedback-modal')" class="sub-header-link">Feedback</a>

        <span class="px-2 text-gray-400">/</span>
        <router-link :to="{ name  : 'help-home' }" tag="a" class="sub-header-link" target="_blank">Help Centre</router-link>
        
        <span class="px-2 text-gray-400">/</span>
        <a href="#" v-on:click="logout()" class="sub-header-link">Logout</a>
      </div>

      <template v-if="$store.state.view == 'broker'">
        <div class="flex items-center">

          <a href="#" :class="{
            'w-8 h-8 text-white rounded-full flex justify-center items-center mr-10' : true,
            'bg-gray-400 hover:bg-gray-600' : !hasNewFormItems,
            'bg-red-500 hover:bg-red-600' : hasNewFormItems
          }" 
            v-if="$store.state.view == 'broker' && items != null && items.length > 0"
            @click.prevent="$modal.show('forum-item-modal', { items : items })">
            <svg width="16" height="16" stroke-width="2" class="" stroke="currentColor" fill="none">
              <use xlink:href="/static/img/feather-sprite.svg#bell"/>
            </svg>
          </a>

          <template v-if="$store.state.brokerModule.broker.subscription.stripe != null || $store.state.brokerModule.broker.free_access">
            <a href="#" class="bg-indigo-500 px-6 py-2 rounded-sm text-white font-semibold mr-2" 
              @click.prevent="$modal.show('forum-modal')">Access {{ getAppName }} Forum</a>  
          </template>

          <template v-else>
            <template v-if="$store.state[$store.state.view + 'Module'].broker.trial_ended">
              <router-link :to="{
                name : 'broker-stripe',
                params : {
                  brokerId : $store.state[$store.state.view + 'Module'].broker.id
                }
              }"
              v-if="$store.state.brokerModule.broker.suspended"
              tag="a"
              class="bg-orange-600 px-4 py-1 text-xs rounded-sm mr-4 text-center text-white font-semibold">Upgrade to get access to all features!</router-link>
            </template>

          </template>

          <router-link :to="{
            name : 'broker-referral',
            params : {
              brokerId : $store.state[$store.state.view + 'Module'].broker.id
            }
          }" tag="a"
          class="bg-red-500 hover:bg-red-600 px-6 py-2 rounded-sm text-center text-white font-semibold">
            Refer &amp; Get One Month Free!
          </router-link>
        </div>
      </template>

      <template v-else-if="$store.state.view == 'client'">
        <!-- <a href="#" 
          class="bg-blue-500 hover:bg-blue-600 px-6 py-2 rounded-sm text-center text-white font-semibold"
          v-on:click.prevent="$modal.show('register-modal')">Create an Account for Easy Access!</a> -->
          
        <a href="#" 
          class="bg-blue-500 hover:bg-blue-600 px-6 py-2 rounded-sm text-center text-white font-semibold"
          v-on:click.prevent="$modal.show('register-modal')">Create an Account for Easy Access!</a>
      </template>
    </div>

    <RegisterModal />
    <ForumModal />
    <ForumItemModal :setLastForumItemChecked="setLastForumItemChecked" />
  </div>
</template>

<script>
  import RegisterModal    from '@/shared/components/modals/RegisterModal'
  import ForumModal       from '@/shared/components/modals/ForumModal'
  import ForumItemModal   from '@/shared/components/modals/ForumItemModal'

  export default {
    components : {
      RegisterModal,
      ForumModal,
      ForumItemModal
    },

    data() {
      return {
        items          : null,
        hasNewFormItems: false
      }
    },

    created() {
      this.apiGet({

      }, 'auth/latest-forum-items', (items) => {
        if(items.length > 0) {
          this.items = items
          this.setLastForumItemChecked()
        }
      })
    },

    methods : {
      setLastForumItemChecked() {
        let lastTimeChecked  = this.$cookies.get('forum-item-last-checked-at')
        this.hasNewFormItems = this.items[0].created_at > lastTimeChecked
      }
    }
  }
</script>